import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import styles from './DisabledButton.module.scss';

const DisabledButton = ({ title }) => (
  <button
    className={classnames('btn', styles['disabled-button'])}
    disabled
    type="button"
  >
    {title}
  </button>
);

DisabledButton.propTypes = {
  title: PropTypes.string.isRequired,
};

export default DisabledButton;
